import { render, staticRenderFns } from "./_productShortages.vue?vue&type=template&id=151c5f19&scoped=true&"
import script from "./_productShortages.vue?vue&type=script&lang=js&"
export * from "./_productShortages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151c5f19",
  null
  
)

export default component.exports